// extracted by mini-css-extract-plugin
export default {"tableWrapper":"style_tableWrapper__ufZgY","table":"style_table__Lre9s","lockButton":"style_lockButton__gqQ0A","popAndSpiral":"style_popAndSpiral__JzvTj"};